import { DesignLayoutType } from '@graphql/generated';
import { PhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';
import { PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT } from './useHeaderPhotoPresentationData.constants';
import type { SupportedHeaderPhotoLayoutSchema } from '@shared/types/WebsiteHeaderSettings.types';

export const getHeaderPhotoSchemaUrlByWebsiteLayout = (layout: DesignLayoutType, headerPhotoPresentationLayout: PhotoPresentationLayout) => {
  const maybeSchemaUrlForPresentationLayout: string | null = headerPhotoPresentationLayout
    ? // @ts-expect-error - Type is present but not derived as it is json string
      PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT[layout]?.[headerPhotoPresentationLayout]?.schemaUrl
    : null;

  return maybeSchemaUrlForPresentationLayout;
};

export const getHeaderPhotoSchemaConfig = (layout: DesignLayoutType, headerPhotoPresentationLayout: PhotoPresentationLayout) => {
  const maybeConfig: { schemaUrl: string; template: SupportedHeaderPhotoLayoutSchema } | null =
    // @ts-expect-error - Type is present but not derived as it is json string
    PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT[layout]?.[headerPhotoPresentationLayout] || null;

  return maybeConfig;
};

export const getHeaderPhotoLayoutBySchemaUrl = (schemaUrl: string, layout: DesignLayoutType) => {
  const maybeLayout: PhotoPresentationLayout | null =
    Object.values(PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT[layout]).find(value => value.schemaUrl === schemaUrl)?.template.presentationLayout || null;

  return maybeLayout;
};
